import { requestJson } from '../../services/_core';

export async function fetchTourProgress(tourName) {
  try {
    const data = await requestJson('GET', '/users/tour-progress/', null, null, { tourName });
    return { ok: true, progress: data?.progress ?? null };
  } catch {
    return { ok: false, progress: null };
  }
}

export function saveTourProgress(tourName, progress) {
  return requestJson('POST', '/users/tour-progress/', { tourName, progress });
}
